
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {EntityHeaderContainerModel} from '../../../../../../models/aggregates/erp/entity';
import {BaseApiTemplateService, Core2Config} from '../../shared';


@Injectable({
  providedIn: 'root'
})
export class SupplierHeaderService extends BaseApiTemplateService<EntityHeaderContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity-hdrs/suppliers';
    this.endpoint_path =  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity-hdrs/suppliers';
    this.httpClient = http;
  }
 
}
